const topics = [
  { name: '黑料在线观看', count: '326万讨论', icon: 'ri-eye-line', color: 'primary' },
  { name: '黑料在线播放', count: '258万讨论', icon: 'ri-play-circle-line', color: 'accent' },
  { name: '黑料视频', count: '213万讨论', icon: 'ri-vidicon-line', color: 'secondary' },
  { name: '娱乐圈爆料', count: '187万讨论', icon: 'ri-star-line', color: 'primary' },
  { name: '网红翻车', count: '162万讨论', icon: 'ri-emotion-line', color: 'accent' },
  { name: '综艺黑幕', count: '145万讨论', icon: 'ri-tv-line', color: 'secondary' },
  { name: '明星八卦', count: '131万讨论', icon: 'ri-heart-line', color: 'primary' },
  { name: '黑料大瓜', count: '118万讨论', icon: 'ri-cake-line', color: 'accent' },
  { name: '在线观看黑料', count: '96万讨论', icon: 'ri-film-line', color: 'secondary' },
  { name: '实锤证据', count: '84万讨论', icon: 'ri-file-search-line', color: 'primary' },
  { name: '黑料在线免费观看', count: '72万讨论', icon: 'ri-money-cny-circle-line', color: 'accent' },
];

const colorStyles: Record<string, { bg: string; text: string; hover: string }> = {
  primary: { bg: 'bg-primary-50', text: 'text-primary-700', hover: 'hover:bg-primary-100' },
  accent: { bg: 'bg-accent-50', text: 'text-accent-700', hover: 'hover:bg-accent-100' },
  secondary: { bg: 'bg-secondary-50', text: 'text-secondary-700', hover: 'hover:bg-secondary-100' },
};

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex items-center gap-3 mb-2">
          <span className="w-10 h-10 flex items-center justify-center bg-accent-500 rounded-lg">
            <i className="ri-hashtag text-background-50 text-xl"></i>
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">热门话题</h2>
        </div>
        <p className="text-foreground-500 text-sm mb-8 md:mb-10 ml-13">全网热议 · 黑料在线社区最受关注的话题标签</p>

        <div className="flex flex-wrap gap-3">
          {topics.map((topic) => {
            const cs = colorStyles[topic.color];
            return (
              <a
                key={topic.name}
                href="#media"
                className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-full ${cs.bg} ${cs.text} ${cs.hover} transition-colors cursor-pointer text-sm font-medium`}
              >
                <i className={`${topic.icon} text-base`}></i>
                <span>{topic.name}</span>
                <span className="text-xs opacity-60 whitespace-nowrap">{topic.count}</span>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}